namespace TabAurous.Common {
    export interface _ExcelImportLabourResponse extends Serenity.ServiceResponse {
        Labours?: OMS.ProductMasterLaborRow[];
        RateIssues?: RateIssues[];
    }
}
